<template>
    <div class="d-flex flex-column align-center">
        <v-form v-model="valid">
            <v-card class="mt-2" max-width='500px' width='97%'>
 
                <v-card-text> <span>{{$t("integrations.config_access")}}:</span> </v-card-text>

                <v-card-text>

                    <v-text-field class="ozmap-api" :rules="generalRules" :disabled='integrated' persistent-hint :hint='$t("integrations.ozmapAPIkeyHint")' v-model="ozmapAPIkey" :label="$t('integrations.ozmapAPIkey')" outlined> </v-text-field>

                    <v-text-field class="ozmap-url" :rules="generalRules" :disabled='integrated' v-model="ozmapUrl" :label="$t('integrations.ozmapURL')" outlined> </v-text-field>

                </v-card-text>

            </v-card>

            <v-card class="mt-2" max-width='500px' width='97%' height='100%'>

                <v-card-text> <span>{{$t("integrations.integration_options")}}:</span> </v-card-text>

                <v-card-text>

                    <v-text-field class="ozmap-name" :rules="nameRules" :disabled='integrated' v-model="name" :label='$t("integrations.name")' outlined> </v-text-field>
                    <v-text-field :disabled='integrated' persistent-hint :hint='$t("integrations.ozmapRadiusHint")' type="number" v-model="options.areaRadius" :label="$t('integrations.ozmapRadius')" outlined> </v-text-field>
                    <v-checkbox :disabled='integrated' v-model="options.wipeAreas" :label="$t('integrations.wipeAll')" color="red darken-3" :hint='$t("integrations.wipeAllhint")' persistent-hint></v-checkbox>

                </v-card-text>

                <v-card-text>

                </v-card-text>

                <v-card-actions class="d-flex justify-center mt-n3">

                    <v-row>

                        <v-col class="d-flex justify-center">
                            <v-btn  @click="integrate" class="mb-3 btn-send" :disabled='!valid' :loading='loading' color='primary'>
                                <span>{{$t('integrations.new_integration')}}</span>

                            </v-btn>
                        </v-col>

                    </v-row>

                </v-card-actions>

            </v-card>

        </v-form>
    </div>
</template>

<script>
import validators from '../../../utils/validators'; 
import { mapActions } from 'vuex'
import { CREATE_INTEGRATION } from '../../../store/mutations'

export default {
    name: 'OzmapIntegrationCard',
    data() {
        return {
            ozmapAPIkey: '',
            ozmapUrl: '',
            options: {
                areaRadius: 100,
                wipeAreas: false,
            }, 
            loading: false,
            integrationData: {},
            integrated: false,
            lastIntegration: '',
            integrationStatus: '',
            name: '',
            nameRules: [
                v => validators.name.required(v) || this.$t('validators.name.required'),
            ],
            generalRules: [
                v => validators.name.required(v) || this.$t('validators.required'),
            ],

            valid: false
        }
    },

    computed: {

    },

    methods: {
      
      ...mapActions({ createIntegration: `ProviderVuex/${CREATE_INTEGRATION}` }),

      async integrate() {

          this.loading = true

          try {

                await this.createIntegration({ integrator: 'ozmap', api_key: this.ozmapAPIkey, url: this.ozmapUrl, last_sync: Date.now(), name: this.name, options: this.options })

                this.$emit('newIntegration')

                return this.showToast(this.$t('integrations.saved_msg'), this.$t('integrations.saved_title'), 'info')
             
          } catch (error) {

                console.log(error)            

                return this.showToast(error.message, this.$t('integrations.saved_title'), 'error')
              
          } finally {

              this.loading = false

          }
      },

    },

}
</script>
